module.exports = __webpack_public_path__ + "static/media/sort-shapes-down.b75cd9d5.svg";